var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "top-button", attrs: { href: "javascript:;" } },
        [
          _c("el-button", { attrs: { type: "primary" } }, [
            _vm._v("群考核名单")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "淘金客" } },
            [_c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "合作公司" } },
            [
              _c("providerautocomplete", {
                on: { callBack: _vm.updateProviderId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否通过" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.passState,
                    callback: function($$v) {
                      _vm.passState = $$v
                    },
                    expression: "passState"
                  }
                },
                [
                  _c("el-option", {
                    key: "Passed",
                    attrs: { label: "通过", value: "Passed" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Failed",
                    attrs: { label: "未通过", value: "Failed" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "NotExamine",
                    attrs: { label: "未考", value: "NotExamine" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Loss",
                    attrs: { label: "流失", value: "Loss" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Cancel",
                    attrs: { label: "取消资格", value: "Cancel" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "签到次数" } },
            [
              _c("el-input", {
                attrs: { clearable: "" },
                model: {
                  value: _vm.checkInTimes,
                  callback: function($$v) {
                    _vm.checkInTimes = $$v
                  },
                  expression: "checkInTimes"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "签到时间" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择开始日期"
                },
                on: { change: _vm.changeHandlerStart },
                model: {
                  value: _vm.checkInStartTime,
                  callback: function($$v) {
                    _vm.checkInStartTime = $$v
                  },
                  expression: "checkInStartTime"
                }
              }),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择结束日期"
                },
                on: { change: _vm.changeHandlerEnd },
                model: {
                  value: _vm.checkInEndTime,
                  callback: function($$v) {
                    _vm.checkInEndTime = $$v
                  },
                  expression: "checkInEndTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _vm.list.length > 0
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getExcel } },
                    [_vm._v("导出")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.endOperatorExam }
                },
                [_vm._v("结束培训")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "tab" },
        _vm._l(_vm.examiningList, function(t, key) {
          return _c(
            "li",
            { class: { active: t.isCurrent } },
            [
              t.isCurrent
                ? [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/tjkStudy/enterExam?id=" +
                            t.operatorExamId +
                            "&groupId=" +
                            _vm.groupId +
                            "&groupName=" +
                            _vm.groupName,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(t.operatorName) +
                            "  考核人数：" +
                            _vm._s(t.examNum)
                        )
                      ]
                    )
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(t.operatorName) +
                        "  考核人数：" +
                        _vm._s(t.examNum) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c(
                  "p",
                  {
                    staticClass: "tj-shift-notice",
                    staticStyle: { "padding-top": "45px" }
                  },
                  [_vm._v("暂无记录！")]
                )
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "loginName",
                          label: "电话",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "companyName",
                          label: "公司简称",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "checkInTimes",
                          label: "签到次数",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: scope.row.passState,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "passState", $$v)
                                      },
                                      expression: "scope.row.passState"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      key: "Passed",
                                      attrs: { label: "通过", value: "Passed" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Failed",
                                      attrs: {
                                        label: "未通过",
                                        value: "Failed"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "NotExamine",
                                      attrs: {
                                        label: "未考",
                                        value: "NotExamine"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Loss",
                                      attrs: { label: "流失", value: "Loss" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Cancel",
                                      attrs: {
                                        label: "取消资格",
                                        value: "Cancel"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "综合得分", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "只能填写数字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.score,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "score", _vm._n($$v))
                                    },
                                    expression: "scope.row.score"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "备注", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: "",
                                    placeholder: "不能超过200字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.remark,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "remark", $$v)
                                    },
                                    expression: "scope.row.remark"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.checkGroup }
                        },
                        [_vm._v("群考核")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveScore }
                        },
                        [_vm._v("保存打分")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.releaseGroup }
                        },
                        [_vm._v("发布成绩")]
                      )
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "check" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.callPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "callPhone", _vm._n($$v))
                    },
                    expression: "check.callPhone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 平均外呼时长（分钟）：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.averageDuration,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "averageDuration", _vm._n($$v))
                    },
                    expression: "check.averageDuration"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b416614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b416614","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/provider/operatorExamine.vue
// module id = 1198
// module chunks = 0